
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import HelpOutline from '@material-ui/icons/HelpOutline';
import { withStyles } from '@material-ui/core';

const styles = {
  helperIcon: {
    padding: '20px',
  },
};

const TooltipHelper =  ({classes, title, placement}) => <Tooltip title={title} placement={placement}>
  <IconButton className={classes.helperIcon}>
    <HelpOutline />
  </IconButton>
</Tooltip>;

export default withStyles(styles)(TooltipHelper);
